import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import { formatCount } from "@/utils/format";

export default function FeaturedEvents() {
  const [headline, ...rest] = events;
  const side = rest.slice(0, 2);

  if (!headline) return null;

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
      <article className="group relative overflow-hidden rounded-lg border border-background-200 lg:col-span-7">
        <Link to={`/event/${headline.id}`} className="block h-72 w-full overflow-hidden md:h-[420px]">
          <img
            src={headline.cover}
            alt={`${headline.title} 事件封面图`}
            title={`${headline.title} - 热门吃瓜网友热评`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
        </Link>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
        <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
              今日头条
            </span>
            <span className="rounded-full bg-background-50/15 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
              {headline.categoryName}
            </span>
            <span className="flex items-center gap-1 text-xs text-background-50/80">
              <i className="ri-fire-line text-sm text-accent-400"></i>
              {formatCount(headline.heat)}
            </span>
          </div>
          <h3 className="font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">
            <Link to={`/event/${headline.id}`} className="transition-colors hover:text-accent-300">
              {headline.title}
            </Link>
          </h3>
          <p className="mt-3 line-clamp-2 max-w-2xl text-sm text-background-100/85 md:text-base">
            {headline.summary}
          </p>
          <Link
            to={`/event/${headline.id}`}
            className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-300"
          >
            进入围观现场
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </article>

      <div className="flex flex-col gap-6 lg:col-span-5">
        {side.map((item) => (
          <article
            key={item.id}
            className="group flex flex-1 gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300"
          >
            <Link to={`/event/${item.id}`} className="h-24 w-28 shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-36">
              <img
                src={item.cover}
                alt={`${item.title} 事件封面图`}
                title={`${item.title} - 热门吃瓜网友热评`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </Link>
            <div className="flex min-w-0 flex-1 flex-col">
              <span className="text-xs font-semibold text-secondary-700">{item.categoryName}</span>
              <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-950">
                <Link to={`/event/${item.id}`} className="line-clamp-2 transition-colors hover:text-primary-600">
                  {item.title}
                </Link>
              </h3>
              <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-sm text-primary-500"></i>
                  {formatCount(item.heat)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line text-sm"></i>
                  {formatCount(item.commentCount)}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}